import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import TitleFooter from '../../Components/TitleFooter/TitleFooter'
import './Footer.css'
import mojavez1 from '../../Assets/images/mojavez1.png'
import { MdEmail } from 'react-icons/md'
import { BsInstagram, BsWhatsapp, BsTelegram } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import zarinpalImg from '../../Assets/images/1.png';

export default function Footer() {
    return (
        <>

            <div className='footer-section'>
                <div className='footer-wrapper'>
                    <Container className='footer-container'>
                        <Row>
                            <Col xs={6} lg={3}>
                                <div className='footer-menu'>
                                    <TitleFooter title='منو کاربردی سایت' />
                                    <ul>
                                        <li>
                                            <Link to='/'>
                                                صفحه اصلی
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/courses'>
                                                دوره های آموزشی
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/products'>
                                                محصولات
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/articles'>
                                                مقالات
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                            <Col xs={6} lg={3}>
                                <div className='footer-social-link'>
                                    <TitleFooter title='شبکه های اجتماعی' />
                                    <ul>
                                        <li>
                                            <BsInstagram />
                                            <a href="https://www.instagram.com/senik.co">
                                                اینستاگرام
                                            </a>
                                        </li>
                                        <li>
                                            <BsTelegram />
                                            <a href="https://t.me/+989203693646">
                                                تلگرام
                                            </a>
                                        </li>
                                        <li>
                                            <BsWhatsapp />
                                            <a href="https://wa.me/+989203693646">
                                                واتس اپ
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                            <Col xs={12} lg={4}>
                                <div className='footer-permissions'>
                                    <TitleFooter title='مجوز های ما' />
                                    <div className='permissions-images'>
                                        <div className='permissions-image'>
                                            <img src={mojavez1} alt="" />
                                        </div>
                                        <div className='permissions-image'>
                                            <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=450119&Code=zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=450119&Code=zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0' alt='مجوز اینماد برای سه نیک' style={{ cursor: 'pointer' }} Code='zAgTd61FlvlcLcV8aAOJs8SYZInJvZE0' /></a>
                                        </div>
                                        <div className='permissions-image'>
                                            <a referrerpolicy='origin' target='_blank' href='https://www.zarinpal.com/trustPage/senikcompany.com'>
                                                <img src={zarinpalImg} alt="تاییده زرین پال برای سه نیک" />
                                            </a>
                                        </div>
                                    </div>


                                </div>
                            </Col>
                            <Col xs={12} lg={2}>
                                <div className='mobile-number'>
                                    <a href="mailto:admin@senikcompany.com">
                                        <div>
                                            <div className='email-icon'>
                                                <MdEmail />
                                            </div>
                                            company.senik@gmail.com
                                        </div>
                                    </a>

                                </div>
                            </Col>
                        </Row>
                        <div className='footer-paragraph'>
                            <p>
                                سازمان علمی آموزشی سه نیک، حاصل ده‌ها سال تجربه، تلاش، تحقیق و جمع آوری اطلاعات توسط آقای دکتر منوچهر مزداپور می‌باشد. هدف سه‌نیک همانطور که از نامش پیداست ترویج نیکی و کمک به یکدیگر برای رسیدن به جامعه‌ای مستقل و پویاست که در راستای این هدف خدمات و آموزش‌های ویژه‌ای را با موضوع مدیریت تولید، تولید محصولات کاربردی، صنایع بزرگ، متوسط و خرد و خانگی ارائه می‌دهد؛ که بخش بزرگی از این آموزش‌ها به صورت کاملا رایگان در اختیار شما عزیزان قرار می‌گیرد. تمامی مطالب به صورت مداوم آپدیت می‌شوند و همواره می‌توانید به بروزترین اخبار و اطلاعات صنایع گوناگون از طریق پلتفرم سه‌نیک دسترسی داشته باشید. همچنین پشتیبانی 24 ساعته در وبسایت و دیگر شبکه‌های اجتماعی وابسته به سه‌نیک، جهت راهنمایی و پاسخ به سوالات شما عزیزان در اختیارتان قرار دارد. شما عزیزان از هرنقطه‌ی این کره‌ی خاکی دعوتید تا به خانواده بزرگ سه‌نیک بپیوندید و بدون هیچ محدودیتی به ده‌ها ویدیوی آموزشی، مقاله علمی، پادکست و... دسترسی داشته باشید
                            </p>
                        </div>
                    </Container>
                </div>

                <Link to={"https://web-seven.ir"}>
                    <div className='codeland'>
                        طراحی شده توسط شرکت وب سون
                    </div></Link>
            </div>
        
        </>

    )
}
